import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import axios from 'components/AppRequest';
import { showSpashScreen, hideSpashScreen, setServerRespondedToAjax, setUserLogged }
  from 'components/actions/authActions';
import NoLogin from 'components/components/dashboard/NoLogin';
import PropTypes from 'prop-types';
import T from 'components/common/translations/Translate';
import NoConnection from 'components/components/common/NoConnection';

const propTypes = {
  path: PropTypes.string,
  callback: PropTypes.func,
  softLoading: PropTypes.bool
};

const Loading = () => {
  return (
    <div className="content content--msg content--no-shapes">
      <div className="content__desc">
        <i className="loader"></i>
      </div>
    </div>
  )
}

class SecureLoadingContent extends Component {

  constructor(props) {
    super(props);
    var isLoaded = false;
    if (this.props.softLoading) {
      isLoaded = props.serverRepondedToAjax;
    }

    this.state = {
      loaded: isLoaded,
      forbidden: props.isLogged ? false : true,
    }
  }

  componentDidMount() {
    // this.props.showSpashScreen();
    this.loadContent();
  }

  checkUserIsLogged() {
    axios.post('/pwa/security/check-login')
      .then(response => {
        this.setState({ loaded: true, forbidden: false, connectionProblem: false });
        this.updateServerResponded();
        this.props.setUserLogged(response.data);
        // this.props.hideSpashScreen();
      })
      .catch(error => {
        if (error.response) {
          this.setState({ loaded: true, forbidden: true, connectionProblem: false });
        } else {
          this.setState({ loaded: true, forbidden: false, connectionProblem: true });
        }
      });
  }

  loadContent = () => {
    if (this.props.path) {
      this.sendPassedRequest();
    } else {
      this.checkUserIsLogged();
    }
  }

  sendPassedRequest() {
    axios({
      method: this.props.method ? this.props.method : "get",
      url: this.props.path,
      data: this.props.params ? this.props.params : null
    })
      .then(response => {
        if (this.props.callback) {
          this.props.callback(response.data);
        }
        this.setState({ loaded: true, forbidden: false, connectionProblem: false });
        this.updateServerResponded();
        // this.props.hideSpashScreen();
      })
      .catch(error => {
        if (error.response) {
          this.setState({ loaded: true, forbidden: true, connectionProblem: false });
          if (error.response.status >= 400 && error.response.status <= 499) {
            // this.props.hideSpashScreen();
          }
        } else {
          this.setState({ loaded: true, forbidden: false, connectionProblem: true });
        }
      });
  }

  updateServerResponded = () => {
    if (!this.props.serverRepondedToAjax) {
      this.props.setServerRespondedToAjax(true);
    }
  }

  render() {
    if (!this.state.loaded) {
      return (<Loading />);
    }

    if (this.state.loaded && this.state.connectionProblem) {
      if (this.props.softLoading) {
        return this.props.children;
      } else {
        return (
          <div className="content content--msg">
            <div className="content__desc">
              <NoConnection loadContent={this.loadContent} />
            </div>
          </div>
        );
      }
    }

    if (this.state.loaded && this.state.forbidden === false) {
      return this.props.children;
    } else {
      return (
        <NoLogin locale={this.props.locale} />
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    locale: state.app.locale,
    serverRepondedToAjax: state.auth.serverRepondedToAjax
  }
}

SecureLoadingContent.propTypes = propTypes;

export default withRouter(
  connect(
    mapStateToProps,
    { showSpashScreen, hideSpashScreen, setServerRespondedToAjax, setUserLogged }
  )(SecureLoadingContent)
);
